/**
 * Pickup Availability component
 * 
 * @module component-pickup-availability
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-pickup-availability';

if (!customElements.get(customElements.component)) {
 
    class componentPickupAvailability extends HTMLElement {

        /**
         * Pickup Availability component
         * 
         * @constructor
         */
        constructor() {

            super();

            this.render();

            this.initEvents();
        }
        
        /**
         * Render component in the DOM
         * 
         * @returns {undefined}
         */
        render() {
            let html = this.template();
            this.innerHTML = html;
            this.dataset.ready =  true;
        }
                
        /**
         * Component template
         * 
         * @returns {undefined}
         */
        template() {

            return `
                <side-drawer id="pickup_availability_drawer" data-side="right">
                    <div class="w-full px-4 flex flex-col pb-6">
                        <div
                            data-store-availability-container
                            data-product-title=""
                            data-has-only-default-variant=""
                            data-base-url="">
                        </div>                        
                    </div>
                </side-drawer>
            `;
        }
        
        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            window.addEventListener('pickup-availability', event => {
                this.reload(event.detail.variantId).then(event => {
                    this.open();
                });
            });


            document.querySelectorAll('[pickup-availability-target]').forEach( element => {
                element.addEventListener('click', () => {

                    // Dispatch addtocart event
                    let event = new CustomEvent('pickup-availability', {'detail': {
                        variantId: element.dataset.variantId
                    }});
                    window.dispatchEvent(event);

                });
            });

        }

        /**
         * Open Pickup Availability
         * 
         * @returns {undefined}
         */
        open() {

            this.querySelector('#pickup_availability_drawer').open();
        }

        /**
         * Close Pickup Availability
         * 
         * @returns {undefined}
         */
        close() {

            this.querySelector('#pickup_availability_drawer').close();
        }

        /**
         * Reload component
         * 
         * @returns {undefined}
         */
        reload(variantId) {

            return new Promise((resolve, reject) => {
                fetch(`${window.Shopify.routes.root}variants/${variantId}/?section_id=pickup-availability`)
                .then(response => response.text())
                .then(text => {

                    const container = this.querySelector('[data-store-availability-container]');

                    const pickupAvailabilityHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('.shopify-section');

                    container.innerHTML = "";

                    container.appendChild(pickupAvailabilityHTML);

                    return true;
                })
                .then( a => {
                    resolve(true);
                })
                .catch(e => {
                    console.error(e);
                });
            });

        }

    }

    customElements.define(customElements.component, componentPickupAvailability);
}